import { render } from "./DeleteCommentConfirmationModal.vue?vue&type=template&id=c852e510&scoped=true"
import script from "./DeleteCommentConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DeleteCommentConfirmationModal.vue?vue&type=script&lang=js"

import "./DeleteCommentConfirmationModal.vue?vue&type=style&index=0&id=c852e510&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c852e510"]])

export default __exports__